import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pa_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (value) => {
  if (value == null) return "";
  return new Intl.NumberFormat("bg-BG", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value);
};

// Proxy WP-hosted images through backend (hotlink protection bypass)
export const resolveImg = (url) => {
  if (!url) return url;
  if (url.includes("/api/img")) return url;
  if (url.includes("penichart.com")) return `${API}/img?u=${encodeURIComponent(url)}`;
  return url;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Възникна грешка. Опитайте отново.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
